(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ShiftNote', ShiftNote);

    ShiftNote.$inject = ['$resource'];

    function ShiftNote ($resource) {
        var resourceUrl =  'api/shift-notes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
